<template>
	
	<div class="selected-filter" v-bind:class="'selected-filter selected-filter--' + this.iconByType(type)">
		<span>{{ title }}</span>
		<button v-on:click="handleRemove">
			<svg xmlns="http://www.w3.org/2000/svg" width="17.81" height="17.75" viewBox="0 0 17.81 17.75"><path fill="currentColor" d="M17.73 2.85L14.9.02 8.89 6.03 2.88.02.05 2.85l6.01 6.01-6.01 6.01 2.83 2.83 6.01-6.01 6.01 6.01 2.83-2.83-6.01-6.01 6.01-6.01z"/></svg>
		</button>
	</div>

</template>
 
<script>
export default {
	props: {
		value: [Number, String],
		title: String,
		type: String
	},
	methods: {
		handleRemove() {
			this.$store.commit(
				'filterRemove',
				{
					type: this.type,
					value: this.value
				}
			);	
		}
	}
}
</script> 